import React from "react";
import { ComparisonPanel, IComparisonPanelProps } from "../../../components/panels/ComparisonPanel";

export type GetComparisonPanelProps =
  IComparisonPanelProps & { id: string };

export const getComparisonPanel = ({
  id,
  title,
  variant,
  isBetterV2,
  headingType,
  content,
  callToAction,
  backgroundColour,
  link,
  comparisonCards,
}: GetComparisonPanelProps) => (
  <ComparisonPanel
    key={id}
    title={title}
    variant={variant}
    isBetterV2={isBetterV2}
    headingType={headingType}
    content={content}
    callToAction={callToAction}
    backgroundColour={backgroundColour}
    link={link}
    comparisonCards={comparisonCards}
  />
);
